import { Icon } from "../Icon";
import { IIcon } from "../interfaces/IIcon";

export const openIcon: IIcon = new Icon(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill-rule="evenodd" d="M27.608 0a3.765 3.765 0 1 1 0 7.53H7.529v48.94h48.942V36.393a3.765 3.765 0 0 1 7.529 0v20.079A7.53 7.53 0 0 1 56.47 64H6.276v-.104A7.531 7.531 0 0 1 0 56.47V7.529A7.53 7.53 0 0 1 7.53 0h20.078Zm31.204 0A5.188 5.188 0 0 1 64 5.188V20.75a3.458 3.458 0 0 1-6.917 0V11.76L27.341 41.5a3.424 3.424 0 0 1-4.842-4.842L52.241 6.917H43.25a3.458 3.458 0 0 1 0-6.917h15.562Z"/></svg>`
);
